import { EHelpCenterType } from '@portals/help-center-core';

export const getHelpCenterType = (isSideMode: boolean): EHelpCenterType => {
  return isSideMode ? EHelpCenterType.DRAWER : EHelpCenterType.MAIN;
};
